// Import the existing standard information popover
import { InfoButton } from "global/components/InfoButton";
import ModerationIcon from "global/strich_icons/StrichIcons";


// Use the header API status names and existing moderation circle colours
const moderationStates = {
    pass: { label: "Pass", className: "approved" },
    partial_fail: { label: "Partial fail", className: "mixed" },
    fail: { label: "Fail", className: "rejected" },
    pending: { label: "Awaiting moderation", className: "pending" },
};


// Show one aggregate circle with the four saved moderation outcomes
const PodDesignListModeration = ({ moderation }) => {

    // Hide this control when no header moderation is available
    if (!moderation) { return null; }

    // Use the API-calculated overall status without recalculating it in React
    const overall = moderationStates[moderation.status];
    if (!overall) { return null; }

    // Keep the four categories in the same order as the design editor
    const categories = [
        { key: "design_text", label: "Design text" },
        { key: "design_images", label: "Design images" },
        { key: "product_text", label: "Product text" },
        { key: "product_images", label: "Product images" },
    ];

    return (
        <span className="pod-moderation__indicator pod-designs__list-moderation" onClick={(event) => event.stopPropagation()}>
            <InfoButton
                buttonIcon={
                    <>
                    
                    <span
                        className={`pod-moderation__circle pod-moderation__panelCircle pod-moderation__circle--${overall.className}`}
                        title={`Moderation: ${overall.label}`}
                    />
                    {/* <ModerationIcon status={overall.className} /> */}
                    </>

                }
                shortLabel={`Moderation: ${overall.label}`}
                description={
                    <div className="pod-moderation__details pod-designs__moderation-summary">
                        <div className="pod-moderation__popoverHeader">
                            <strong>Moderation: {overall.label}</strong>
                        </div>

                        {/* Show the four category results without loading their individual issues */}
                        <div className="pod-designs__moderation-summary-items">
                            {categories.map((category) => {

                                // Resolve each category's status for its label and circle
                                const status = moderationStates[moderation[category.key]] || moderationStates.pending;

                                return (
                                    <div key={category.key} className="pod-designs__moderation-summary-row">
                                        <span>{category.label}</span>
                                        <span className="pod-designs__moderation-summary-value">
                                            <span className={`pod-moderation__circle pod-moderation__circle--${status.className}`} />
                                            {status.label}
                                        </span>
                                    </div>
                                );

                            })}
                        </div>
                    </div>
                }
            />
        </span>
    );

};

export default PodDesignListModeration;